import request from './request'

export function listOtherOut(data) {
  return request.post('/inventory/other-outs/list', data)
}
export function getOtherOut(id) {
  return request.get('/inventory/other-outs/' + id)
}
export function saveOtherOut(data) {
  return request.post('/inventory/other-outs', data)
}
export function updateOtherOut(data) {
  return request.post('/inventory/other-outs/update', data)
}
export function deleteOtherOut(ids) {
  return request.post('/inventory/other-outs/delete', ids)
}
export function approveOtherOut(stockOutId) {
  return request.post('/inventory/other-outs/approve', { stockOutId })
}
export function unapproveOtherOut(stockOutId) {
  return request.post('/inventory/other-outs/unapprove', { stockOutId })
}
